import { useTranslation } from "react-i18next"
import { Warning } from "@phosphor-icons/react"

export const ChatMessageTranslationFailed = () => {
  const { t } = useTranslation()

  return (
    <div className="text-critical flex items-center gap-1 text-xs">
      <Warning size={16} />
      <span>{t("chat.autoTranslation.translationFailed")}</span>
    </div>
  )
}
